import React from 'react';
import { Link, useMatch } from 'react-router';
import regularStyles from './styles/Tabs.module.scss';
import reportingStyles from './styles/ReportingTabs.module.scss';

type LinkProps = {
  children: React.ReactNode;
  to: string;
  mobile?: boolean;
  reporting?: boolean;
  role?: string;
};
type Active = {
  activeTab: string;
  setActiveTab: (value: React.SetStateAction<string>) => void;
};
type Tab = {
  key: string;
  label: string;
  link?: string;
  mobile?: boolean;
};

type TabsProps = {
  active?: Active;
  block?: boolean;
  tabs: Tab[];
  reporting?: boolean;
};

const NavLink: React.FunctionComponent<LinkProps> = (props: LinkProps) => {
  const href = props.to;
  const match = useMatch(href);
  const styles = props.reporting ? reportingStyles : regularStyles;

  const isActive =
    match ||
    (location.pathname.includes('/customerService/') && location.pathname !== '/customerService/contact' && href !== '/customerService/contact');

  return (
    <Link
      to={href}
      className={`${styles.tab} ${props.mobile === true ? styles.mobileShow : props.mobile === false ? styles.mobileHide : ''} ${
        isActive ? styles.active : ''
      }`}
      aria-current={isActive ? 'page' : false}
      role={props.role}
    >
      {props.children}
    </Link>
  );
};

const Tabs: React.FunctionComponent<TabsProps> = (props: TabsProps) => {
  const { tabs, block, reporting } = props;

  const styles = reporting ? reportingStyles : regularStyles;

  return (
    <div className={`${styles.tabContainer} ${block ? styles.block : ''}`} role="tablist">
      {tabs.map((tab) => {
        if (props.active) {
          return (
            <button
              key={tab.key}
              type="button"
              className={`${styles.tab} ${tab.mobile === true ? styles.mobileShow : tab.mobile === false ? styles.mobileHide : ''} ${
                props.active.activeTab === tab.key ? styles.active : ''
              }`}
              onClick={(): void => props.active?.setActiveTab(tab.key)}
              role="tab"
              aria-selected={props.active.activeTab === tab.key}
            >
              {tab.label}
            </button>
          );
        } else {
          return (
            <NavLink key={tab.key} to={tab.link ?? ''} mobile={tab.mobile} reporting={reporting} role="tab">
              {tab.label}
            </NavLink>
          );
        }
      })}
    </div>
  );
};

export default Tabs;
